import React from 'react';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { Task } from './api';
import {
  User,
  getCurrentUserFullName,
} from 'donor/portal/pages/FeedbackDashboard/Feedback/utils';
import { FormatUTC } from 'shared/utils/formatUTC';

interface TaskCompletedMetaProps {
  completionDate: string;
  task: Task;
  currentUser: User | undefined;
  className?: string;
}

const TaskCompletedMeta: React.FC<TaskCompletedMetaProps> = ({
  completionDate,
  task,
  currentUser,
  className,
}) => {
  const date = new FormatUTC(completionDate);
  const completedUser = `${task.completionUser?.firstName} ${task.completionUser?.lastName}`;
  const user = getCurrentUserFullName(currentUser);
  return (
    <TrueImpactText variant="body-small" className={className}>
      <div>
        <strong>Completed:</strong> {date.formatDate()}
      </div>
      <div>
        <strong>Completed by:</strong>{' '}
        {completedUser === user ? `You (${completedUser})` : completedUser}
      </div>
    </TrueImpactText>
  );
};

export default TaskCompletedMeta;
